import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc60 = {
    title: "Image 60: Example of accessible kiosk heights at the filing counter.",
    para1: <>
        <p>The image is a technical diagram showing the accessible kiosk heights derived from the Harmonised Guidelines 2021. </p>
        <p>The diagram shows both sides of the counter. On the right side, the representation of a man sitting in a chair is shown with labelling that shows that the maximum height of the counter should be 800 mm. On the left side of the counter, figures representing a man in a wheelchair and a woman carrying an infant are shown. The labelling states that the minimum height of the counter should be 600 mm and the depth should be 480 mm.</p>
    </>,
}

export const ImageDesc61 = {
    title: "Image 61: Accessible e-kiosk/electronic system.",
    para1: "The image shows an example of electronic kiosks at an airport. One of the kiosks is designated as an electronic kiosk with the universal symbol of accessibility, i.e., a wheelchair symbol, on top of it. The counter is lower than the other e-kiosks with a wider screen."
}

export const FigureDesc50 = {
    title: "Figure 50: Typical floor plan for the filing section and scrutiny branch. ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The plan provides for a scrutiny branch at the top, and a filing section at the bottom. Both spaces are connected by a door of 900 mm. The features of each space are described from top to bottom.
        </p>
        <p><span><b>Description:</b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Scrutiny Branch:
                        {getCircleTypeListItem([
                            "The scrutiny branch measures 7300 mm x 3600 mm. ",
                            "At the centre of the room, a six-seater table is provided with chairs for the staff. The seating provisions include wheelchair-accessible seating. ",
                            "The table is equipped with digital technology, including computer systems and IT services.",
                            "Storage is provided along the walls on the left side of the room and along the back wall of the scrutiny branch room.",
                            "A photocopy machine has been installed on the top right corner of the room.",

                        ])}
                    </>,

                    <>
                        Filing Section:
                        {getCircleTypeListItem([
                            "The counter area of the filing section measures 7300 mm x 2900 mm.",

                            "Four counters, including a wheelchair-accessible counter has been provided with seating for staff provided on one side, and the counters being open to the public on the other. The counters are equipped with digital technology.",

                            "Storage is provided along the walls on the back wall of the room.",

                            "To the right of the accessible counter, an opening of turning diameter 1500 mm is provided, leading to the public area of the filing section.",

                            "The public area has a xerox machine and two information kiosks, including an accessible kiosk, on the right. A surface has been provided for the use of persons to peruse/sign documents, etc.",

                        ])}
                    </>,


                ])}
            </div>
        </p>
    </>
}